import { render, staticRenderFns } from "./tpl-9.vue?vue&type=template&id=6405cafd&scoped=true"
import script from "./tpl-9.vue?vue&type=script&lang=js"
export * from "./tpl-9.vue?vue&type=script&lang=js"
import style0 from "./tpl-9.vue?vue&type=style&index=0&id=6405cafd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6405cafd",
  null
  
)

export default component.exports